import { apiUrls } from "@mindlercare/schema";
import { TextField, useSnackbar } from "@mindlercare/ui-web";
import CustomModal from "components/lib/customModal";
import { useTranslation } from "react-i18next";
import { getMarketBasedRegion } from "../../../../helpers/getCountryCode";
import { usePsychologistUser } from "../../../../hooks";

const subscribeToCalendarUrl = `${
  apiUrls[import.meta.env.VITE_STAGE][getMarketBasedRegion()].stranglerApiUrl
}/apiv2/webcal/subscribe`;

export const SubscribeToCalenderItem = ({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { psychologist, isLoading } = usePsychologistUser();
  const url = `${subscribeToCalendarUrl}?code=${window.btoa(
    `type=psychologist&id=${psychologist?.user?.userId}`,
  )}`;

  if (isLoading) {
    return null;
  }

  const handleCopyLink = async () => {
    close();
    await window.navigator.clipboard.writeText(url);
    enqueueSnackbar({
      text: t("COPY_LINK_SUCCESS"),
    });
  };

  return (
    <CustomModal.Wrapper
      size="large"
      onClose={close}
      titleText={t("SUBSCRIBE_TO_MINDLER_CALENDER")}
      open={open}
    >
      <CustomModal.Paragraph>
        {t("SUBSCRIBE_TO_CALENDAR_DESCRIPTION")}
      </CustomModal.Paragraph>
      <TextField
        width="full"
        label={t("SUBSCRIBE_TO_CALENDAR_COPY_LABEL")}
        hideSensitiveData={false}
        value={url}
        onChange={() => {
          // this field is not optional, so just do nothing.
          return;
        }}
      />
      <CustomModal.ButtonRow paddingTop={24}>
        <CustomModal.Button
          variant="secondary"
          onClick={close}
          text={t("CANCEL")}
        ></CustomModal.Button>
        <CustomModal.Button
          variant="primary"
          onClick={() => handleCopyLink()}
          text={t("COPY_LINK")}
        ></CustomModal.Button>
      </CustomModal.ButtonRow>
    </CustomModal.Wrapper>
  );
};
